var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13207 25.334C6.39859 25.1635 5.09999 24.6428 4.22909 23.7719C2.66699 22.2099 2.66699 19.6956 2.66699 14.6673V14.0007C2.66699 8.97233 2.66699 6.45818 4.22909 4.89608C5.79119 3.33398 8.30534 3.33398 13.3337 3.33398H18.667C23.6953 3.33398 26.2095 3.33398 27.7715 4.89608C29.3337 6.45818 29.3337 8.97233 29.3337 14.0007V14.6673C29.3337 19.6956 29.3337 22.2099 27.7715 23.7719C26.2095 25.334 23.6953 25.334 18.667 25.334C17.9197 25.3507 17.3245 25.4075 16.7398 25.5407C15.1419 25.9085 13.6623 26.7261 12.2002 27.4392C10.1167 28.4551 9.07499 28.9631 8.42125 28.4875C7.17058 27.556 8.39305 24.6699 8.66699 23.334",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame21);
export default __webpack_public_path__ + "static/media/Frame (21).54387a48867bc0f845b8be9b7f0bff82.svg";
export { ForwardRef as ReactComponent };